export default __webpack_public_path__ + "static/media/project-at-risk-health.87e60703.svg";